export const palette = {
	darkCyan: '#2E353A',
	lightGrayishBlue: '#F2F7FE',
	gray: {
		50: '#f6f6f6',
		75: '#F8FBFF',
		100: '#babfc7', // lightest
		200: '#ededed', // lighter
		300: '#dae1e7', // light
		400: '#636363',
		500: '#adb5bd',
		600: '#b8c2cc', // $gray
		625: '#625D76',
		650: '#4e5154',
		700: '#445065',
		725: '#7E84A3',
		750: '#363B4D',
		800: '#1e1e1e', // dark
		900: '#2a2e30',
		950: '#2E353A'
	},
	markedField: '#E7024C'
};
